// extracted by mini-css-extract-plugin
module.exports = {"head":"Product_head__1e8To","title":"Product_title__eyaOQ"};